import { SVGProps, useMemo } from 'react';

import { useTheme } from '@/features/theme-switch';

const Refresh = ({
  internal,
  ...props
}: SVGProps<SVGSVGElement> & { internal?: boolean }) => {
  const { darkTheme } = useTheme();

  const color = useMemo(() => (darkTheme ? '#FFFFFF' : '#A0A8AA'), [darkTheme]);

  return (
    <svg
      width={20}
      height={20}
      fill="none"
      viewBox="0 0 20 20"
      stroke={internal ? 'white' : color}
      {...props}
    >
      <path
        d="M3.33203 3.3335V7.77794M3.33203 7.77794H7.77648M3.33203 7.77794C5.05606 6.23083 6.65268 4.47925 9.06931 4.13926C10.5007 3.93789 11.9587 4.20713 13.2238 4.90641C14.4888 5.60569 15.4923 6.69713 16.0831 8.01629M16.6654 16.6668V12.2224M16.6654 12.2224H12.2209M16.6654 12.2224C14.9413 13.7695 13.3447 15.5211 10.9281 15.8611C9.49669 16.0624 8.03863 15.7932 6.77359 15.0939C5.50854 14.3946 4.50504 13.3032 3.91428 11.984"
        stroke="current"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Refresh;
